// hooks/useCheckAnswer.js
import { useRef, useCallback, useEffect } from "react";
import { fetchData } from "../utils/apiUtils";

export default function useCheckAnswer(
  query,
  currentQuestionId,
  onAnswered,
  setShowAnswerBox,
  answerBoxDismissed,
  dismissedQuestionId
) {
  const timerRef = useRef(null);
  const answeredRef = useRef(false);

  const stopChecking = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const startChecking = useCallback(() => {
    if (!query) return;
    // avoid double timers
    stopChecking();
    answeredRef.current = false;

    // poll every 2s (tune as needed)
    timerRef.current = setInterval(async () => {
      try {
        const data = await fetchData(query);
        const teamStarted = Number(data?.started) > 0;
        const teamAnswered = Number(
          data?.answered ?? data?.answerOK ?? data?.isAnswered
        ) > 0;

        if (
          teamStarted &&
          !teamAnswered &&
          !answerBoxDismissed &&
          !answeredRef.current &&
          dismissedQuestionId !== currentQuestionId
        ) {
          setShowAnswerBox(true);
        }

        if (teamAnswered) {
          if (answeredRef.current) return;
          answeredRef.current = true;
          stopChecking();
          setShowAnswerBox(false);

          if (typeof onAnswered === "function") onAnswered(currentQuestionId);
        }
      } catch (e) {
        // Optional: backoff or just keep trying
        // console.error("check failed", e);
      }
    }, 1000);
  }, [
    query,
    currentQuestionId,
    onAnswered,
    setShowAnswerBox,
    answerBoxDismissed,
    dismissedQuestionId,
    stopChecking,
  ]);

  // Safety: stop timer if component unmounts
  useEffect(() => stopChecking, [stopChecking]);

  return { startChecking, stopChecking };
}
